import React from "react";
import "./productMobileFilter.css";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MobileProductFilterContainer from "../../../../../panels/mobile/multiLocQuotePanel/components/mobileProductContainer";

interface ProductGridProps {
  products: string[];
  selectedProduct: string;
  setSelectedProduct: (product: string) => void;
  onClose?: () => void;
  isColumnLayout?: boolean;
}

const ProductMobileFilter: React.FC<ProductGridProps> = ({
  products,
  selectedProduct,
  setSelectedProduct,
  onClose,
  isColumnLayout = true,
}) => {

  if (!isColumnLayout) {
    return (
      <MobileProductFilterContainer
        products={products}
        selectedProduct={selectedProduct}
        onProductSelect={setSelectedProduct}
        onClose={onClose}
      />
    );
  }

  return (
    <div
      className={`product-grid-container ${"multi-loc-layout"
        }`}
    >

      <div className="multi-loc-header">
        <div className="header-content">
          <span className="header-title">Product Type</span>
          <div
            className="close-button-wrapper"
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
              if (onClose) onClose();
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                e.stopPropagation();
                if (onClose) onClose();
              }
            }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="header-divider" />
      </div>


      <div
        className={`${"product-grid-multi-location-quote"}`}
      >
        {products.map((product) => {
          // If no valid product is selected, default to AMMONIA
          const hasValidSelection =
            selectedProduct && products.includes(selectedProduct);
          const isSelected =
            selectedProduct === product ||
            (!hasValidSelection && product === "AMMONIA");

          return (
            <Button
              key={product}
              className={`product-button ${isSelected ? "selected" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedProduct(product);
              }}
            >
              {product}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default ProductMobileFilter;
